import type {WebSearchReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {Link} from '@primer/react'

import {ReferencePreview} from './ReferencePreview'
import styles from './WebSearchReferencePreview.module.css'

export function WebSearchReferencePreview<T extends WebSearchReference>({
  reference,
  onDismiss,
}: {
  reference: T
  onDismiss?: () => void
}) {
  return (
    <ReferencePreview.Frame>
      <ReferencePreview.Header onDismiss={onDismiss}>
        <div className={styles.headerContent}>
          <BingIcon />
          <span className={styles.searchSummary}>
            <span className={styles.resultCount}>
              {reference.results.length} {reference.results.length === 1 ? ' result ' : ' results '}
            </span>
            from Bing search.
          </span>
        </div>
      </ReferencePreview.Header>
      <ReferencePreview.Body detailsError={false} detailsLoading={false}>
        <div className={styles.resultsList}>
          {reference.results.map((result, index) => (
            <div
              className={styles.resultCard}
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={index}
            >
              <Link className={styles.resultLink} href={result.url} rel="nofollow">
                {result.title}
              </Link>
              <div>{result.excerpt}</div>
              <div className={styles.resultUrl}>{result.url}</div>
            </div>
          ))}

          <span className={styles.privacyNote}>
            <Link href="https://privacy.microsoft.com/en-us/privacystatement" rel="nofollow" target="_blank">
              Microsoft Privacy Statement
            </Link>
          </span>
        </div>
      </ReferencePreview.Body>
    </ReferencePreview.Frame>
  )
}

export const BingIcon = () => <div className={styles['bing-icon']} />
